import React from 'react';

import { getNotFoundError } from '@app/core/widgets/pages';

import { ErrorCard } from '../ErrorCard/ErrorCard';
import { CommonErrorDialogFooter } from '../ErrorDialog/CommonFooter/CommonFooter';

/**
 * Error dialog with page not found error.
 * Commonly used for fallback routes.
 * @returns page not found component.
 */
export const PageNotFoundDialog = () => (
  <ErrorCard
    error={getNotFoundError()}
    footer={<CommonErrorDialogFooter isInternalError={false} />}
  />
);
